<button *ngIf="(claimable$ | async)" class="dropdown-item"
        (click)="claim()">
  <ng-container *ngIf="(isProcessing$ | async) !== true else spinner">
    {{'context-menu.actions.claim.btn' | translate}}
  </ng-container>

</button>

<ng-template #spinner>
  <i class="fa fa-spinner fa-spin fa-fw"></i>
  <span class="sr-only">Loading...</span>
</ng-template>
